/**
 * The series colours of the period sections, in order (design streaming-sections: s1, s2, s3, s6).
 * Theme variables, so light and dark both work.
 */
export const PERIOD_SERIES_COLORS = ['var(--brand-violet)', 'var(--brand-pink)', 'var(--pos)', 'var(--tx-3)'] as const;

/** The colour of the series at an index. Past the list the last colour repeats. */
export function periodSeriesColor(index: number): string {
  return PERIOD_SERIES_COLORS[Math.min(index, PERIOD_SERIES_COLORS.length - 1)] ?? 'var(--tx-3)';
}
